
import { defineComponent, ref, onMounted, PropType, watch } from 'vue';
import { ILatLngLiteral } from '@/types';

export default defineComponent({
    name: "BusStopMapDialog",
    props: {
      currentBusStopPostion: {
        type: Object as PropType<ILatLngLiteral>,
        default: () => ({})
      }
    },
    setup(props) {
      const map = ref<any>(null);
      const center = ref<ILatLngLiteral>({
        lat: 25.0325917,
        lng: 121.5624999
      });
      const initMap = () => {
        center.value = {
          lat: Number(props.currentBusStopPostion.lat),
          lng: Number(props.currentBusStopPostion.lng)
        };
        map.value = new (window as any).google.maps.Map(document.getElementById("map") as Element, {
          center: center.value,
          zoom: 15,
          maxZoom: 20,
          minZoom: 3,
          streetViewControl: false,
          mapTypeControl: false,
          disableDefaultUI: true,
        });
        const marker = new (window as any).google.maps.Marker({
          position: center.value,
          map: map.value,
        });
      };

      const goUseGps = () => {
        window.open(`https://www.google.com/maps/dir/${props.currentBusStopPostion.lat},${props.currentBusStopPostion.lng}`);
      };

      watch(() => props.currentBusStopPostion, (v) => {
        center.value = {
          lat: Number(v.lat),
          lng: Number(v.lng)
        };
        initMap();
      });

      onMounted(async() => {
        initMap();
      });
      return {
        goUseGps
      };
    },
})
